import script from "./ShareRecommendationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShareRecommendationModal.vue?vue&type=script&setup=true&lang=ts"

import "./ShareRecommendationModal.vue?vue&type=style&index=0&id=6218dc6b&lang=sass&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6218dc6b"]])

export default __exports__